import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import logo from '../assets/sb-logo.png';

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: '#fff',
        borderTop: '1px solid #eee',
        py: 3,
        mt: 6,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.03)',
      }}
    >
      <Container maxWidth="md">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={2} alignItems="center">
            <Box component="img" src={logo} alt="Shaadi Biodata Logo" sx={{ height: 36, width: 'auto' }} />
            <Typography variant="body2" color="text.secondary">
              &copy; {year} Create Shaadi Biodata. All rights reserved.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={3} alignItems="center">
            <Link href="/privacy-policy.html" underline="hover" color="primary" variant="body2">
              Privacy Policy
            </Link>
            <Link href="/about.html" underline="hover" color="primary" variant="body2">
              About Us
            </Link>
            <Link href="/terms.html" underline="hover" color="primary" variant="body2">
              Terms &amp; Conditions
            </Link>
            <Link href="/contactus.html" underline="hover" color="primary" variant="body2">
              Contact Us
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
} 